// extracted by mini-css-extract-plugin
export var errorsContainer = "_w6-1";
export var link = "_w6-0";